import { render, staticRenderFns } from "./TopEmployeesTable.vue?vue&type=template&id=560a0acd&scoped=true&"
import script from "./TopEmployeesTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopEmployeesTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TopEmployeesTable.vue?vue&type=style&index=0&id=560a0acd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a0acd",
  null
  
)

export default component.exports